/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/credit_note'
export default icon
